<template>
    <div class="DocuBreak-container">
        <div>
            <h1 style="font-size: 24px;">{{title}}</h1>
            <p>{{description}}</p>
        </div>

        <div id="command-container">
            <p class="section-title">Command</p>
            <code class="docu-code-snippet">{{commandString}}</code>
        </div>

        <div id="parameters-container">
            <p class="section-title">Parameters</p>
            <ul style="margin-bottom: 10px">
                <li v-for="(parameter, i) in parameters" :key="i"><b>{{parameter.name ? parameter.name : "none"}}</b> {{parameter.desc}} </li>
            </ul>
        </div>

        <v-expansion-panels accordion flat id="docu-accordion-container">
            <v-expansion-panel>
                <v-expansion-panel-header class="docu-accordion-header" >Examples</v-expansion-panel-header>
                <v-expansion-panel-content class="docu-accordion-header">
                    <code class="accord-code-snippet">
                        <p class="accord-p-tag"  v-for="(example, i) in examples" :key="i">{{example}}</p>
                    </code>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header class="docu-accordion-header">Shortcuts</v-expansion-panel-header>
                <v-expansion-panel-content class="docu-accordion-header">
                    <code class="accord-code-snippet">
                        <p class="accord-p-tag" style="margin: 0" v-for="(shortcut, i) in shortcuts" :key="i">{{shortcut}}</p>
                    </code>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- TODO: Finish the output here -->
            <v-expansion-panel>
                <v-expansion-panel-header class="docu-accordion-header">Output</v-expansion-panel-header>
                <v-expansion-panel-content class="docu-accordion-header">
                    Output preview coming soon!
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>


<script>
export default {
    name: 'DocuBreak',

    props: {
        title: String,
        commandString: String,
        description: String,
        parameters: Array,
        examples: Array,
        shortcuts: Array
    },

    mounted() {        
    },
    
    components: {
        
    },

    methods: {
    
    },

    data: () => ({


    }),
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .DocuBreak-container {
        height: auto;
        width: 100%;

        display: flex;
        flex-direction: column;
        border-bottom: #C5C5C5 1px solid;
        margin-bottom: 20px;
    }

    .section-title {
        font-weight: bold;
        color: #9A9A9A;
        padding-top: 10px;
        margin-bottom: 10px;
    }

    #command-container {

    }

    .docu-code-snippet {
        width: 100%;
        color: #ffffff;
        
        background-color: #282828;
        border: #9B9B9B 1px solid;
        padding: 10px;
        border-radius: 10px;        
    }

    #parameters-container {
        margin-top: 10px;
    }

    #docu-accordion-container {
        margin-top: 10px;
        margin-bottom: 20px;
        background-color: #292929;
    }

    .docu-accordion-header {
        background-color: #292929;
    }

    .accord-code-snippet {
        display: block;
        white-space: pre-wrap;
        padding: 0.5rem 10px;
        width: 100%;
        color: #ffffff;

        background-color: #282828;
        border: #9B9B9B 1px solid;
        border-radius: 10px;
    }

    .accord-p-tag {
        margin: 0;
    }

</style>
